import { customDashboardConfigConstants } from './CustomDashboard.constants';

const initialState = {
  dashboards: {},
  selectedDashboard: {},
  mode: 'view',
  mapping: {
    list: []
  },
  nickNameList: [],
  isLoadingChart: false,
  onPublishConfig: { metricList: [], groupBy: '' },
  onChangeConfig: {}
};

const CustomDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- GEt custom dashboards list
    case customDashboardConfigConstants.GET_CUSTOM_DASHBOARDS_REQUEST:
      return {
        ...state,
        dashboards: {
          loading: true,
          error: false
        }
      };

    case customDashboardConfigConstants.GET_CUSTOM_DASHBOARDS_SUCCESS:
      return {
        ...state,
        dashboards: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case customDashboardConfigConstants.GET_CUSTOM_DASHBOARDS_ERROR:
      return {
        ...state,
        dashboards: {
          loading: false,
          error: true
        }
      };

    // --- GEt Mapping list
    case customDashboardConfigConstants.GET_MAPPING_REQUEST:
      return {
        ...state,
        mapping: {
          loading: true,
          error: false
        }
      };

    case customDashboardConfigConstants.GET_MAPPING_SUCCESS:
      return {
        ...state,
        mapping: {
          loading: false,
          error: false,
          list: action.payload
        }
      };

    case customDashboardConfigConstants.GET_MAPPING_ERROR:
      return {
        ...state,
        mapping: {
          loading: false,
          error: true
        }
      };

    // --- GEt custom dashboards details
    case customDashboardConfigConstants.GET_SELECTED_CUSTOM_DASHBOARD_REQUEST:
      return {
        ...state,
        selectedDashboard: {
          loading: true,
          error: false
        }
      };

    case customDashboardConfigConstants.GET_SELECTED_CUSTOM_DASHBOARD_SUCCESS:
      return {
        ...state,
        selectedDashboard: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case customDashboardConfigConstants.GET_SELECTED_CUSTOM_DASHBOARD_ERROR:
      return {
        ...state,
        selectedDashboard: {
          loading: false,
          error: true
        }
      };

    case customDashboardConfigConstants.UPDATE_CHART_CONFIGS:
      return {
        ...state,
        dashboard: {
          list: action.payload
        }
      };

    case customDashboardConfigConstants.ADD_CHART_CONFIGS:
      return {
        ...state,
        dashboard: {
          list: [action.payload, ...state.dashboard.list]
        }
      };

    // --- Store selected dashboard config in redux
    case customDashboardConfigConstants.SELECTED_CUSTOM_DASHBOARD:
      return {
        ...state,
        selectedDashboard: {
          ...action.payload
        }
      };

    // ---- Edit dashboard status
    case customDashboardConfigConstants.EDIT_DASHBOARD_STATUS:
      return {
        ...state,
        mode: action.payload
      };

    // ---- Nick name list
    case customDashboardConfigConstants.GET_NICKNAME_LIST:
      return {
        ...state,
        nickNameList: action.payload
      };

    // ---- chart Loading Status
    case customDashboardConfigConstants.IS_LOADING_CHART:
      return {
        ...state,
        isLoadingChart: action.payload
      };

    // ---- chart Loading Status
    case customDashboardConfigConstants.UPDATE_CONFIG:
      return {
        ...state,
        ...action.payload
      };

       // ---- chart Loading Status
    case customDashboardConfigConstants.DIMENSION_LIST:
      return {
        ...state,
        dimensionList: action.payload,
      };

    // ---- chrome extension metrics list
    case customDashboardConfigConstants.CHROME_METRICS_LIST:
      return {
        ...state,
        chromeMetricsList: action.payload,
      };

    case customDashboardConfigConstants.UPDATE_ROW_LIMIT:
      return {
        ...state,
        rowLimit: action.payload,
      };

    default:
      return state;
  }
};

export default CustomDashboardReducer;
